import PropTypes from 'prop-types';

const titleTable = ['id', 'email', 'firstname', 'phoneNumber', 'vgid', 'deviceId', 'roleName', 'deactivated', 'mfaEnabled', 'forceMfa', 'lastname'];
// const Model = {
//     id: PropTypes.string,
//     name: PropTypes.string,
//     email: PropTypes.string,
//     role: PropTypes.string,
//     password: PropTypes.string,
//     status: PropTypes.bool,
// };
export default { titleTable }
